export const getDifferenceInValues = <T>(
  setValues: T[],
  initialState: Record<string, boolean>,
  excludeValue?: string,
): Record<string, boolean> => {
  const deltaValue: Record<string, boolean> = {};
  (Object.entries(initialState) as [T, boolean][]).forEach(([key, value]) => {
    if (setValues.includes(key) && !value && key !== excludeValue) {
      deltaValue[key as string] = true;
    }

    if (!setValues.includes(key) && value && key !== excludeValue) {
      deltaValue[key as string] = false;
    }
  });

  return deltaValue;
};
